import { useCurrentSubscription } from "@dashboard/workspaces/api/helpers";

import { useGetFdroidsQuery } from "./index";

function useGetCurrentWorkspaceFdroids() {
    const { data: subscription } = useCurrentSubscription({});
    const noSubscription = !subscription?.id;
    return useGetFdroidsQuery({ subscriptionId: subscription?.id }, { skip: noSubscription });
}

export { useGetCurrentWorkspaceFdroids };
